// src/stores/authStore.ts

import { create } from 'zustand';

interface AuthState {
    isLoggedIn: boolean;
    isShebaLoading: boolean;
    isAuthVerified: boolean;
    setIsLoggedIn: (status: boolean) => void;
    setIsAuthVerified: (status: boolean) => void;
    setIsShebaLoading: (status: boolean) => void;
}

const useAuthStore = create<AuthState>((set) => ({
    isLoggedIn: false,
    isShebaLoading: false,
    isAuthVerified: false,
    setIsShebaLoading: (status: boolean) => set({ isShebaLoading: status }),
    setIsLoggedIn: (status: boolean) => set({ isLoggedIn: status }),
    setIsAuthVerified: (status: boolean) => set({ isAuthVerified: status }),
}));

export default useAuthStore;
